import { createAction } from 'redux-actions';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { CustomAxios, getErrorMessage } from '../../../axios';
import { showError, addAlert } from '@weave/alert-system';

export const enableAnalyticsUi = createAction('ENABLE_ANALYTICS_UI');

export const handleEnableAnalyticsUi = function* () {
  try {
    yield call(CustomAxios.post, '/support/v1/analytics-admin/onboarding/ui', {
      enabled: true,
    });
    yield put(addAlert({ type: 'info', message: 'Enabled Analytics UI' }));
  } catch (error: any) {
    yield put(showError(getErrorMessage(error)));
  }
};

export const enableAnalyticsUiSaga = function* () {
  yield all([takeEvery(enableAnalyticsUi.toString(), handleEnableAnalyticsUi)]);
};
